import __base_store from '@/store/__base_store'

/**
 * Store de resumen de caja.
 */
export default __base_store({
	state: {
		model_name: 'resumen_caja',
		from_dates: true,
	},
})

